export default function organizations(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            // GUARD: muitos modulos da app dispatcham `type: 'ADD_CURRENT'`
            // sem namespace (techinicalteams, addresses, articles, etc.).
            // Sem este check, qualquer addCurrent de outro modulo sobrescreve
            // organization=undefined, quebrando paginas que dependem do state
            // (ex.: organization-edit + WizardOrganization).
            if (action.organization === undefined) return state;
            return {
                ...state,
                organization: action.organization,
            }
        default:
            return state;
    }
}
